import { TABS } from "../../lib/diagramTabs";

/**
 * Switches which projection of the architecture is drawn (TDD §3.11).
 *
 * Floats over the canvas rather than sitting in the header: the header belongs to the
 * project (name, save, export) while this belongs to the drawing, and putting them in
 * one row made the save state look like it applied per tab.
 */
export default function DiagramTabs({ value, onChange }) {
  return (
    <div
      role="tablist"
      aria-label="Architecture view"
      data-testid="diagram-tabs"
      className="absolute flex items-center"
      style={{
        top: 14,
        left: 16,
        zIndex: 5,
        maxWidth: "calc(100% - 32px)",
        overflowX: "auto",
        gap: 2,
        padding: 3,
        borderRadius: 10,
        background: "var(--color-background-secondary)",
        border: "1px solid var(--color-border-primary)",
        boxShadow: "0 8px 24px -18px rgba(0,0,0,.6)",
      }}
    >
      {TABS.map((tab) => {
        const active = tab.id === value;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            title={tab.hint}
            data-testid={`diagram-tab-${tab.id}`}
            data-active={active ? "true" : "false"}
            onClick={() => onChange(tab.id)}
            className="motion-micro"
            style={{
              appearance: "none",
              border: "none",
              cursor: "pointer",
              height: 30,
              flexShrink: 0,
              whiteSpace: "nowrap",
              padding: "0 14px",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              letterSpacing: "-0.005em",
              background: active ? "var(--color-accent)" : "transparent",
              color: active ? "#0a0a0a" : "var(--color-text-secondary)",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
